import $ from 'jquery';
import {
    TweenMax,
    TimelineLite
} from 'gsap'
import Scrollbar from 'smooth-scrollbar';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';

class Animation{
    run(){
        this.btnBackTop();
        // this.smoothScroll();
        this.animationParallax();
    }

    btnBackTop(){
        $('#btnBackTop').on('click',function(e){
            e.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });

        const controller = new ScrollMagic.Controller();

        // if($('section#hero').length > 0){
        //     var sceneFooter = new ScrollMagic.Scene({
        //         triggerElement: 'section:nth-child(2)',
        //         triggerHook: .5,
        //     })
        //     .setClassToggle('#btnBackTop','active')
        //     .addTo(controller);
        // } else {
        //     $('#btnBackTop').addClass('active');
        // }
    }

    smoothScroll(){
        var scrollContainer = document.querySelector('.main-content');

        scrollContainer.classList.add('smooth-scrollbar')

        var scrollBarScene = Scrollbar.init(scrollContainer, {
            refreshInterval: 0,
            renderByPixels: true,
            continuousScrolling: true,
            syncCallbacks: true,
        });
    }

    animationParallax(){
        const controller = new ScrollMagic.Controller();

        var footer = new TimelineMax();
        footer.staggerFrom('footer p, footer .menu li, footer small, footer .social li', 1, {
            y: 20,
            opacity: 0,
        }, .05)
        .from('footer .logo', 1, {
            y: 30,
            opacity: 0,
        }, '-=1.25');

        var sceneFooter = new ScrollMagic.Scene({
            triggerElement: 'footer',
            triggerHook: 1,
            reverse: false
        })
        .setTween(footer)
        .addTo(controller);

        // HOMEPAGE Parallax
        const pageHome = $('.page-home');
        const pageAmbient = $('.page-ambient');
        if(pageHome.length > 0 || pageAmbient.length > 0){

            var hero = new TimelineMax();

            hero.from('#hero img', 2, {
                opacity: 0,
                y: 10,
            }, 1)
            .from('#hero .subtitle', 2, {
                opacity: 0,
                width: 0,
                y: -10,
            }, '-=1.25')
            .from('#hero .title', 2, {
                opacity: 0,
            }, -.25)
            .from('#hero .pre-title', 2, {
                opacity: 0,
                y: -10,
            }, -.25)
            .from('#hero p', 2, {
                opacity: 0,
                y: 10,
            }, -.25);

            $('section:not(#hero)').each(function(){
                var section = new TimelineMax();

                var preTitle = $(this).find(".pre-title");
                var title = $(this).find(".title");
                var paragraph = $(this).find("p");
                var link = $(this).find("a");
                var img = $(this).find("img");

                section.from(preTitle, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.3em',
                })
                .fromTo(title, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.01em',
                },{
                    opacity: 1,
                    y: 0,
                    letterSpacing: '0',
                }, '-=1.25')
                .from(paragraph, 1, {
                    opacity: 0,
                    y: -30,
                }, '-=1')
                .from(link, 1, {
                    opacity: 0,
                    x: -30,
                }, .15)
                .staggerFrom(img, .5, {
                    opacity: 0,
                }, .05);

                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .7,
                    reverse: false
                })
                // .addIndicators({name: "section"})
                .setTween(section)
                .addTo(controller);
            });

            $('section:not(#hero) img').each(function(){
                var imgParallax = new TimelineMax();

                var img = $(this);

                imgParallax.fromTo(img, 1, {
                    y: 20,
                },{
                    y: -20,
                });

                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .95,
                    duration: '120%',
                    // reverse: false
                })
                // .addIndicators({name: "img"})
                .setTween(imgParallax)
                .addTo(controller);
            });
        }

        // ABOUT Parallax
        const pageAbout = $('.page-about');
        if(pageAbout.length > 0){

            var hero = new TimelineMax();

            hero.from('#hero img', 2, {
                opacity: 0,
                y: 10,
            }, 1)
            .from('#hero .subtitle', 2, {
                opacity: 0,
                width: 0,
                y: -10,
            }, '-=1.25')
            .from('#hero .title', 2, {
                opacity: 0,
            }, -.25)
            .from('#hero .pre-title', 2, {
                opacity: 0,
                y: -10,
            }, -.25)
            .from('#hero p', 2, {
                opacity: 0,
                y: 10,
            }, -.25)
            .from('#hero a', 2, {
                opacity: 0,
                y: 10,
            }, -.25);

            $('section:not(#hero)').each(function(){
                var section = new TimelineMax();

                var preTitle = $(this).find(".pre-title");
                var title = $(this).find(".title, .year");
                var paragraph = $(this).find("p");
                var link = $(this).find("a");
                var img = $(this).find("img");

                section.from(preTitle, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.3em',
                })
                .fromTo(title, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.01em',
                },{
                    opacity: 1,
                    y: 0,
                    letterSpacing: '0',
                }, '-=1.25')
                .from(paragraph, 1, {
                    opacity: 0,
                    y: -30,
                }, '-=1')
                .from(link, 1, {
                    opacity: 0,
                    x: -30,
                }, .15);

                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .7,
                    reverse: false
                })
                // .addIndicators({name: "section"})
                .setTween(section)
                .addTo(controller);
            });

            $('section:not(#hero) img').each(function(){
                var imgParallax = new TimelineMax();

                var img = $(this);

                imgParallax.fromTo(img, 1, {
                    y: 30,
                    opacity:0,
                },{
                    y: -30,
                    opacity:1,
                });

                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .75,
                    duration: '100%',
                    // reverse: false
                })
                // .addIndicators({name: "img"})
                .setTween(imgParallax)
                .addTo(controller);
            });
        }

        // PRODUCTS Parallax
        const pageProducts = $('.page-products');
        const pageBoxes = $('.page-scatole');
        const pageBlog = $('.page-blog');
        if(pageProducts.length > 0 || pageBoxes.length > 0 || pageBlog.length > 0){

            $('section:not(#hero)').each(function(){
                var section = new TimelineMax();

                var preTitle = $(this).find(".pre-title");
                var title = $(this).find(".title");
                var paragraph = $(this).find("p");
                var link = $(this).find("nav li");

                section.from(preTitle, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.3em',
                })
                .fromTo(title, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.01em',
                },{
                    opacity: 1,
                    y: 0,
                    letterSpacing: '0',
                }, '-=1.25')
                .from(paragraph, 1, {
                    opacity: 0,
                    y: -30,
                }, '-=1')
                .staggerFrom(link, 1, {
                    opacity: 0,
                    x: -30,
                }, .15);

                var cover = new TimelineMax();

                cover.to('.cover img', 1, {
                    opacity: .05,
                    x: 50,
                })

                var scene = new ScrollMagic.Scene({
                    triggerElement: '.products-gallery',
                    triggerHook: .4,
                })
                // .addIndicators({name: "section"})
                .setTween(cover)
                .addTo(controller);
            });

            $('section:not(#hero) img').each(function(){
                var imgParallax = new TimelineMax();

                var img = $(this);
                var imgContainer = $(this).parent();

                imgParallax.fromTo(img, .75, {
                    y: 20,
                },{
                    y: 0,
                }).from(imgContainer, .5, {
                    opacity: 0,
                }, '-=1');

                var scene = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .75,
                    // reverse: false
                })
                .setTween(imgParallax)
                .addTo(controller);
            });
        }

        // PRODUCTS Parallax
        const pageServices = $('.page-services');
        if(pageServices.length > 0){

            $('section:not(#hero)').each(function(){
                var section = new TimelineMax();

                var preTitle = $(this).find(".pre-title");
                var title = $(this).find(".title, .subtitle");
                var paragraph = $(this).find("p");
                var link = $(this).find("a");
                var img = $(this).find("img");

                section.from(preTitle, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.3em',
                })
                .fromTo(title, 1, {
                    opacity: 0,
                    y: 30,
                    letterSpacing: '.01em',
                },{
                    opacity: 1,
                    y: 0,
                    letterSpacing: '0',
                }, '-=1.25')
                .from(paragraph, 1, {
                    opacity: 0,
                    y: -30,
                }, '-=1')
                .from(link, 1, {
                    opacity: 0,
                    x: -30,
                }, .15)
                .staggerFrom(img, .5, {
                    opacity: 0,
                }, .05);
            });
        }
    }
}
const animation = new Animation();
export default animation;
